export const EndUserInfoActionTypes = {
    SET_END_USER_INFO:'SET_END_USER_INFO',
    SET_INSTALLER_LOGO:'SET_INSTALLER_LOGO',
    SET_END_USER_INFO_STATUS:'SET_END_USER_INFO_STATUS',
    SET_REMOVE_LOGO_STATUS:'SET_REMOVE_LOGO_STATUS',
    SET_FETCH_LOGO_STATUS:'SET_FETCH_LOGO_STATUS',
}